import { Component, computed, inject, signal } from '@angular/core';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { StepperComponent } from 'app/shared/components/stepper/stepper.component';
import { CreditCardImageComponent } from 'app/shared/components/credit-card-image/credit-card-image.component';
import { Router } from '@angular/router';
import { Themes } from 'themes';
import { ButtonComponent } from 'app/shared/components/button/button.component';
import { BackendService } from 'app/shared/services/backend.service';
import { IbanFormatterPipe } from 'app/shared/pipes/iban-formatter/iban-formatter.pipe';
import { lastValueFrom } from 'rxjs';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';
import { cardPriceFootnotes, isMonthlyCardPrice } from 'app/shared/models/dzbank-configuration.model';
import { BackendErrorType } from 'app/shared/services/errors/backend.errors';
import { CardPriceFootnotesComponent } from 'app/shared/components/card-price-footnotes/card-price-footnotes.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'ez-summary',
  imports: [
    MainLayoutComponent,
    StepperComponent,
    CreditCardImageComponent,
    ButtonComponent,
    IbanFormatterPipe,
    CardPriceFootnotesComponent,
    CurrencyPipe,
  ],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
})
export class SummaryComponent {
  private readonly router = inject(Router);
  private readonly landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);
  private readonly backendService = inject(BackendService);

  readonly orderCreditCardRequestIsLoading = signal(false);
  readonly organisation = this.landingpageConfigurationStateService.organisation;
  readonly cardInformation = this.landingpageConfigurationStateService.cardInformation;
  readonly cardProductTexts = this.landingpageConfigurationStateService.cardProductTexts;
  readonly customer = this.landingpageConfigurationStateService.customer;
  readonly ibanAnonymised = this.landingpageConfigurationStateService.ibanAnonymised;
  readonly canDisplay = computed(
    () => this.organisation() && this.cardInformation() && this.customer() && this.ibanAnonymised(),
  );

  protected readonly Themes = Themes;

  onSubmit() {
    this.orderCreditCardRequestIsLoading.set(true);
    lastValueFrom(this.backendService.orderCreditCard())
      .then(() => {
        this.router.navigate(['completion']);
      })
      .catch((error) => {
        if (error.message === BackendErrorType.ALREADY_SENT) {
          this.router.navigate(['already-sent']);
        } else if (error.message === BackendErrorType.VERIFICATION_ERROR) {
          this.router.navigate(['verification-error']);
        }
      })
      .finally(() => {
        this.orderCreditCardRequestIsLoading.set(false);
      });
  }

  protected readonly isMonthlyCardPrice = isMonthlyCardPrice;
  protected readonly cardPriceFootnotes = cardPriceFootnotes;
}
